export const QuotationConstant = {
    CATEGORY: "Charge",
    TITLE: "Quotation Setting",
    CO_VSL_VOY: 'Co/Vsl/Voy',
    CONSORTIUM_CODE: "Consortium Code",
    VESSEL_CODE: "Vessel Code",
    VOYAGE_CODE: "Voyage Code",
    ETD: "ETD",
    ACTIVE_IND: "Active Ind.",
    QUOTATION_NO: "Quotation No.",
    QUOTATION_DESC: "Quotation Desc.",
    QUOTATION_AMOUNT: "Quotation Amount",
}
export const QuotationRequiredFieldList: string[] = [
    'consortiumCode',
    'vesselCode',
    'voyageCode',
    'etd',
    'quotationNo',
    'quotationDesc',
    'quotationAmount',
    'activeInd',
];